export default "__VITE_ASSET__BG58XyKZ__"